import {
    Scale, Calendar, CalendarDays, CalendarCheck, BarChart3, LineChart, PieChart,
    Check, CheckCircle, CheckCheck, CheckSquare, ChevronDown, ChevronLeft,
    ChevronRight, ChevronUp, Circle, Loader, ClipboardCheck, Clock, Code,
    Settings, Coins, MessageSquare, MessageCircle, Minimize2, Copy, DoorOpen,
    Download, SquarePen, MoreVertical, AlertCircle, AlertTriangle, Eye, EyeOff,
    File as FileIcon, FileSpreadsheet, FileInput, FileText, FileCode, Film,
    Filter, Smile, Globe, HandCoins,
    Home, Image as ImageIcon, Info, Lightbulb, Link as LinkIcon, List, MapPin,
    MinusCircle, Palette, Pencil, Smartphone, Images, Plus, LogOut, Repeat, Route,
    Rocket, CircleDollarSign, Save, Search, Share2, Truck, Signpost,
    SlidersHorizontal, SlidersVertical, ArrowUpDown, RefreshCw, RefreshCcw, X,
    SquareX, Trash2, Tv, Unlink, Upload, User, UserRound, Users, Video, Wallet,
    Asterisk, ArrowLeftRight, ArrowRightFromLine, ArrowLeftFromLine,
    PersonStanding, LayoutGrid, Bell, Target, BadgeCheck, CirclePlay,
} from 'lucide-react';

const MAP = {
    'analytics': BarChart3,
    'angle-down': ChevronDown,
    'angle-left': ChevronLeft,
    'angle-right': ChevronRight,
    'angle-up': ChevronUp,
    'arrow-from-left': ArrowLeftFromLine,
    'arrow-from-right': ArrowRightFromLine,
    'asterisk': Asterisk,
    'badge-check': BadgeCheck,
    'balance-scale': Scale,
    'bells': Bell,
    'bullseye': Target,
    'bullseye-arrow': Target,
    'calendar': Calendar,
    'calendar-alt': CalendarDays,
    'calendar-check': CalendarCheck,
    'chart-bar': BarChart3,
    'chart-line': LineChart,
    'chart-pie': PieChart,
    'check': Check,
    'check-circle': CheckCircle,
    'check-double': CheckCheck,
    'check-square': CheckSquare,
    'chevron-down': ChevronDown,
    'chevron-left': ChevronLeft,
    'chevron-right': ChevronRight,
    'circle': Circle,
    'circle-notch': Loader,
    'clipboard-check': ClipboardCheck,
    'clock': Clock,
    'code': Code,
    'cog': Settings,
    'coin': Coins,
    'coins': Coins,
    'comment-alt-lines': MessageSquare,
    'comment-dots': MessageCircle,
    'compress-wide': Minimize2,
    'copy': Copy,
    'door-open': DoorOpen,
    'download': Download,
    'edit': SquarePen,
    'ellipsis-v': MoreVertical,
    'exclamation-circle': AlertCircle,
    'exclamation-triangle': AlertTriangle,
    'exchange-alt': ArrowLeftRight,
    'eye': Eye,
    'eye-slash': EyeOff,
    'file': FileIcon,
    'file-csv': FileSpreadsheet,
    'file-excel': FileSpreadsheet,
    'file-import': FileInput,
    'file-pdf': FileText,
    'film': Film,
    'filter': Filter,
    'grin-wink': Smile,
    'globe': Globe,
    'html5': FileCode,
    'hand-holding-usd': HandCoins,
    'home': Home,
    'image': ImageIcon,
    'info-circle': Info,
    'lightbulb': Lightbulb,
    'link': LinkIcon,
    'list': List,
    'male': User,
    'female': User,
    'map-marker': MapPin,
    'map-marker-alt': MapPin,
    'street-view': PersonStanding,
    'th': LayoutGrid,
    'minus-circle': MinusCircle,
    'palette': Palette,
    'pen': Pencil,
    'pencil': Pencil,
    'phone-laptop': Smartphone,
    'photo-video': Images,
    'play-circle': CirclePlay,
    'plus': Plus,
    'power-off': LogOut,
    'repeat': Repeat,
    'road': Route,
    'rocket-launch': Rocket,
    'sack-dollar': CircleDollarSign,
    'save': Save,
    'search': Search,
    'share-alt': Share2,
    'shipping-fast': Truck,
    'sign': Signpost,
    'sliders-h': SlidersHorizontal,
    'sliders-v': SlidersVertical,
    'sort': ArrowUpDown,
    'spinner-third': Loader,
    'sync': RefreshCw,
    'sync-alt': RefreshCcw,
    'times': X,
    'times-square': SquareX,
    'trash': Trash2,
    'trash-restore': Trash2,
    'tv': Tv,
    'unlink': Unlink,
    'upload': Upload,
    'usd-circle': CircleDollarSign,
    'user': User,
    'user-circle': UserRound,
    'user-friends': Users,
    'users': Users,
    'users-class': Users,
    'video': Video,
    'wallet': Wallet,
};

const SIZE_MAP = {
    xs: 12,
    sm: 14,
    lg: 24,
    '1x': 16,
    '2x': 32,
    '3x': 48,
    '4x': 64,
    '5x': 80,
    '6x': 96,
    '7x': 112,
    '8x': 128,
    '9x': 144,
    '10x': 160,
};

export default function Icon({
    name,
    size,
    className,
    fixedWidth,
    spin,
    style,
    ...rest
}) {
    // Allow callers to pass a FontAwesome-style tuple [style, name] for the
    // `name` prop (e.g. dynamic icon helpers that still return that shape).
    const key = Array.isArray(name) ? name[1] : name;
    const Cmp = MAP[key];
    if (!Cmp) return null;
    const resolvedSize =
        typeof size === 'number' ? size : SIZE_MAP[size] ?? 12;
    return (
        <Cmp
            className={className}
            size={resolvedSize}
            style={{
                display: 'inline-block',
                verticalAlign: '-0.125em',
                flexShrink: 0,
                ...(style || {}),
            }}
            {...rest}
        />
    );
}